export default class BrowserHelper {
  static pathName(){
    return window.location.pathname;
  }
}
